<template >
  <li class="w-full"  >
    <router-link :to="{ name: item.path, params: item.params }"
      class="parent group flex items-center pr-1 hover:bg-primary-100 dark:hover:bg-darkblue-600 active:bg-primary-200 dark:active:bg-primary-200 animate-hover rounded-sm" >
      <span
        class="link-icon flex-none w-8 h-10 md:h-8 flex items-center justify-center rounded-full dark:group-hover:text-primary"
      >
        <base-icon :name="item.icon" v-if="item.icon" />
      </span>
      <span class="link-name-wrapper w-full overflow-hidden pl-1">
        <span class="link-name truncate group-hover:text-primary dark:group-hover:text-primary" :data-v-step="tourStep">
          {{ item.name }}
        </span>
      </span>
      <span 
        v-show="actualFilterNav"
        class="ml-auto w-8 h-7 flex items-center justify-center cursor-p hover:bg-primary-200 dark:hover:bg-darkblue-600 rounded"
        @click.prevent.stop="onClickFilter()"
        v-popover:popover
        >
        <base-icon name="filter" size="sm" custom="text-secondary-600"/>
      </span>
      <el-popover
        ref="popover"
        placement="right"
        width="320"
        trigger="hover"
        popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
        >
        <div>
          <div v-if="actualFilterNav">
            <div class="flex items-center justify-between">
              <span class="text-lg">{{$i18n.t('app.client_filter')}}</span>
              <base-button-icon
                @click="resetNavFilter()"
                name="cross"
                iconSize="xs"
                size="xs"
                mode="primary-phantom"
                class="ml-2 bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
              />
            </div>
            <div class="flex items-center justify-between">
              <span>{{actualFilterNav.idCliente}} - {{actualFilterNav.Nombre}}</span>
            </div>
          </div>
          <div v-else>
            <span>{{$i18n.t('app.empty_client_filter')}}</span>
          </div>
        </div>    
      </el-popover>
      <span
        v-if="hasLinks"
        @click.prevent="toggle"
        class="arrow ml-auto w-8 h-7 flex-none flex items-center justify-center cursor-p hover:bg-primary-200 dark:hover:bg-darkblue-600 rounded animate-hover"
      >
        <span
          :class="{ 'rotate-180': active }"
          class="transform transition-transform duration-300 dark:text-darkblue-400 dark:hover:text-primary">
          <base-icon name="chevrondown" size="sm" />
        </span>
      </span>
    </router-link>
    <template v-if="hasLinks">
      <transition
        name="list-links"
        @enter="startTransition"
        @after-enter="endTransition"
        @before-leave="startTransition"
        @after-leave="endTransition"
      >
        <ol class="overflow-hidden child-navigation" v-if="active">
          <div v-if="item.subMenu">
            <base-aside-nav-item-group :item="group" v-for="group in item.sc" :key="group.menuId" :title="group.name"/>
          </div>
          <div v-else>
            <base-aside-nav-item-link 
              v-for="link in item.sc" :key="link.name"  
              :link="link"
              />
          </div>
          <span class="h-8 block group-container relative"></span>
        </ol>
      </transition>
    </template>
  </li>
</template>

<script>
import { bus } from '@/main'

export default {
  name: 'aside-nav-item',
  props: {
    item: {
      type: [Object, Array],
      required: true
    },
    role: {
      type: Number,
      default: null
    }

  },
  data: function () {
    return {
      active: true,
    }
  },
  created () {
    this.active = this.itemMenuState
  },
  computed: {
    hasLinks: function () {
      return this.item.sc.length > 0
    },
    tourStep () {
      if (this.item.path === 'certificates') return 1
      if (this.item.path === 'companies') return 3
      return 99999
    },
    actualFilterNav () {
      if (this.item.path === 'invoicesissued') return this.$store.getters['app/idClienteFilterINav']
      if (this.item.path === 'invoicesreceived') return this.$store.getters['app/idClienteFilterRNav']
      if (this.item.path === 'verifactu') return this.$store.getters['app/idClienteFilterVNav']
      return null
    },
    menuState () {
      return this.$store.getters['app/menuState']
    },
    itemMenuState () {
      if (Object.hasOwnProperty.call(this.menuState, this.item?.menuId)) {
        return !!this.menuState[this.item?.menuId]
      }
      return this.item?.menuId !== 7
    }
  },
  methods: {
    resetNavFilter () {
      if (this.item.path === 'invoicesissued') this.$store.dispatch('app/updateidClienteFilterINav', null)
      if (this.item.path === 'invoicesreceived') this.$store.dispatch('app/updateidClienteFilterRNav', null)
      if (this.item.path === 'verifactu') this.$store.dispatch('app/updateidClienteFilterVNav', null)
      bus.$emit('changeIt', 'changed menu')
    },
    toggle: function () {
      this.active = !this.active
      if (Object.hasOwnProperty.call(this.menuState, this.item?.menuId)) {
        const payload = { menuId: this.item?.menuId, active: this.active }
        this.$store.dispatch('app/setMenuState', payload)
      }
    },
    startTransition: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition: function (el) {
      el.style.height = ''
    }
  }
}
</script>

<style lang="scss" scoped>
a.parent {
  @apply pl-4 pr-5;
}
[data-type='main'] {
  a.parent {
    @apply pl-3 pr-1;
  }
}
a.child {
  @apply pl-18;
}
[data-type='main'] {
  a.child {
    @apply pl-11;
  }
}

.group-container{
  @apply bg-primary-50;
  @apply dark:bg-darkblue;
}
[data-type='main'] {
  .group-container{
    @apply bg-white;
    @apply dark:bg-darkblue-900;
  }
}
.animate-hover {
  @apply transition-colors duration-300;
}
.animate-all {
  @apply transition-all duration-300;
}
.cover-subnav {
  @apply border-secondary-100;
}
.span-nav-link-container{
  @apply border-secondary-200;
}
.link-icon {
  @apply text-secondary-500 dark:text-darkblue-400;
}
.link-name {
    @apply text-secondary dark:text-darkblue-200 font-medium;

  }
.link-name.color-link-disabled{
  @apply text-secondary-200;
}
.router-link-active {
  .link-icon {
    @apply text-secondary dark:text-darkblue-200;
  }
  .link-name {
    @apply text-secondary-800 dark:text-darkblue-100 font-bold;
  }
  .cover-subnav {
    @apply border-primary;
  }
  .span-nav-link-container{
    @apply border-primary;
    border-left-width: 4px!important;
  }
}
.rotate-180 {
  transform: rotate(-180deg);
}
.list-links-enter-active,
.list-links-leave-active {
  will-change: height;
  transition: height 0.2s ease;
}
.list-links-enter,
.list-links-leave-to {
  height: 0 !important;
}
</style>
